"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M30 13.5L27.1853 11.5735L29.0485 8.71646L25.7108 8.01374L26.3388 4.66117L22.9863 5.28924L22.2835 1.95151L19.4265 3.81475L17.5 1L15.5735 3.81475L12.7165 1.95151L12.0137 5.28924L8.66117 4.66117L9.28924 8.01374L5.95151 8.71646L7.81475 11.5735L5 13.5",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1 13.25C0.585786 13.25 0.25 13.5858 0.25 14C0.25 14.4142 0.585786 14.75 1 14.75V13.25ZM33 14.75C33.4142 14.75 33.75 14.4142 33.75 14C33.75 13.5858 33.4142 13.25 33 13.25V14.75ZM1 14.75H33V13.25H1V14.75Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1 17.25C0.585786 17.25 0.25 17.5858 0.25 18C0.25 18.4142 0.585786 18.75 1 18.75V17.25ZM33 18.75C33.4142 18.75 33.75 18.4142 33.75 18C33.75 17.5858 33.4142 17.25 33 17.25V18.75ZM1 18.75H33V17.25H1V18.75Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M22 14C22 11.7909 19.9853 10 17.5 10C15.0147 10 13 11.7909 13 14",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.95184 20.7835L9.28957 21.4863L8.6615 24.8388L12.0141 24.2108L12.7168 27.5485L15.5738 25.6853L17.5003 28.5L19.4269 25.6853L22.2839 27.5485L22.9866 24.2108L26.3392 24.8388L25.7111 21.4863L29.0488 20.7835",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

exports.default = Icon;